module.exports = __webpack_public_path__ + "static/media/jtk.ccf86692.png";